






export default {
  name: 'MaterialSymbolsCheck'
}
